// extracted by mini-css-extract-plugin
module.exports = {"select-style":"UISelect_select-style_WfEtg _input-style f-body b"};